import { useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"
import isEqual from 'lodash/isEqual'

const useQaRecordStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('qa_record_statuses_last_updated', 0)
    const [qaRecordStatuses, setQaRecordStatuses] = useLocalStorage('qa_record_statuses', [])
    const [qaRecordTypes, setQaRecordTypes] = useLocalStorage('qa_record_types', [])
    
    useEffect(() => {
        if (qaRecordStatuses.length === 0 || qaRecordTypes.length === 0) {
            reloadQaRecordStatuses()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reloadQaRecordStatuses()
    }, [])

    const reloadQaRecordStatuses = () => {
        setLastUpdated(Date.now())
        fetch('/v0/qa_record_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qaRecordStatuses) ) {
                    setQaRecordStatuses(json.results)
                }
            })
            .catch(error => {
                console.log("QaRecordStatuses reload error", error)
            })
        
        fetch('/v0/qa_record_types', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                if( ! isEqual(json.results, qaRecordTypes) ) {
                    setQaRecordTypes(json.results)
                }
            })
            .catch(error => {
                console.log("QaRecordTypes reload error", error)
            })
    }

    return {
        qaRecordStatuses,
        qaRecordTypes,
        reloadQaRecordStatuses,
    }
}

export default useQaRecordStatuses
